import React from "react";
import { useSearchParams } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import AddOrderPage from "../../components/Orders/AddOrderPage";

const OrderPublicPage = () => {
  const [searchParams] = useSearchParams();

  const companyId = Number(searchParams.get("vendorId"));
  const exCompanyId = Number(searchParams.get("companyId"));
  const orderId = Number(searchParams.get("orderId"));
  
  // Check if only companyId and orderId parameters exist
  const paramKeys = Array.from(searchParams.keys());
  const hasOnlyRequiredParams = paramKeys.length === 3 && paramKeys.includes("vendorId") && paramKeys.includes("orderId") && paramKeys.includes("companyId");

  if (!companyId || !orderId || !hasOnlyRequiredParams || !exCompanyId) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", backgroundColor: "#F5F5F5" }}>
        <Typography color="#005EFF">Invalid link.</Typography>
      </Box>
    );
  }

return (
    <>
      <Box sx={{ width: "100%", height: "100vh", display: "flex", flexDirection: "column", backgroundColor: "#F5F5F5" }}>
        <AddOrderPage
          order={null}
          onSave={() => {}}
          onCancel={() => {}}
          publicCompanyId={companyId}
          publicOrderId={orderId}
          exCompanyId={exCompanyId}
          hideBackButton
        />
      </Box>
    </>
  );
};

export default OrderPublicPage;
